import { CircularProgress } from '@material-ui/core'
import { Pagination, Rating } from '@material-ui/lab'
import axios from 'axios'
import { ceil } from 'lodash'
import React, { useEffect, useState } from 'react'
import { isBrowser } from '../../utils/constants'
import ReviewCard from './ReviewCard'

interface ReviewStats {
  rating: number;
  reviewsCount: number;
}

const ProductReviews = ({ productId }: { productId: string | undefined }) => {

  const [data, setData] = useState<Review[] | null>(null)
  const [reviewStats, setReviewStats] = useState<ReviewStats | null>(null);
  const [page, setPage] = useState(1)
  const REVIEWS_PER_PAGE = 10;

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios(`https://stamped.io/api/widget/reviews?apiKey=pubkey-UM04y4I915o7pwD35vv370t13Wiecx&storeUrl=timelesslacquer.myshopify.com&productId=${productId}&take=${REVIEWS_PER_PAGE}&page=${page}&minRating=1`)
      setData(result.data.data)
      setReviewStats({ rating: result.data.rating, reviewsCount: result.data.total })
    }
    fetchData()
  }, [page])

  const changePage = (page: number) => {
    setPage(page);
    const reviewsBlock = document.getElementById('reviews-block');
    if (isBrowser && data && reviewsBlock) {
      const yCoords = reviewsBlock?.offsetTop;
      window.scrollTo(0, yCoords);
    }
  }

  return reviewStats ? (
    <div className="container review-summary mt-5">
      <div className="row">
        <div className="col-12 text-center review-stars-custom">
          <span className="rating">{reviewStats.rating?.toFixed(1)}</span><Rating style={{ fontSize: '2.8rem' }} name="half-rating" size="large" value={reviewStats.rating} precision={0.5} readOnly />
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-center">
          <p className="paragraph"><span style={{ marginLeft: 10 }}>Based on {reviewStats.reviewsCount} {reviewStats.reviewsCount === 1 ? 'review' : 'reviews'}</span></p>
        </div>
      </div>
      <hr />
      {data ? (
        <>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1">
              {data.map((review, index) => (
                <ReviewCard key={review.id} data={review} noBorder={data.length - 1 === index} />
              ))}
            </div>
          </div>
          {reviewStats.reviewsCount && reviewStats.reviewsCount > REVIEWS_PER_PAGE ? (
            <div className="row">
              <div className="col-12">
                <Pagination style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }} onChange={(e, page) => { changePage(page) }} count={ceil(reviewStats.reviewsCount / REVIEWS_PER_PAGE)} color="primary" />
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <div className="loading text-center">
          <h5>Loading reviews</h5>
          <CircularProgress color="inherit" />
        </div >
      )}
    </div>
  ) : null
}

export default ProductReviews

export interface Review {
  id: number;
  author: string;
  reviewTitle: string;
  reviewMessage: string;
  reviewRating: number;
  reviewDate: string;
  reviewUserPhotos: string;
  reviewUserPhotosWatermark: string;
  reviewVerifiedType: number;
  reviewReply: string;
  productId: number;
  productName: string;
  shopProductId: number;
  productUrl: string;
  productImageUrl: string;
  productImageLargeUrl: string;
  productImageThumbnailUrl: string;
  avatar: string;
  location: string;
  reviewVotesUp: number;
  reviewVotesDown: number;
  dateCreated: string;
  reviewType: number;
  widgetType: string;
  reviewOptionsList: any[];
  featured: boolean;
}

